const styles = {
    primary_color: " rgb(114, 114, 125)",
    secondary_color: "#4fd8ca",
    border_color: " solid 0.1rem #ececec",
};

export default styles;
